import { render } from "./suspended.vue?vue&type=template&id=6ea4655d&scoped=true"
import script from "./suspended.vue?vue&type=script&lang=js"
export * from "./suspended.vue?vue&type=script&lang=js"

import "./suspended.vue?vue&type=style&index=0&id=6ea4655d&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea4655d"]])

export default __exports__